import React from 'react'

import { Box } from '@mui/material'

interface RankBadgeProps {
  rank: number
  // Category/segment color used as the circle fill (e.g. tag-group `colorHex`).
  colorHex: string
  size?: number
}

// A colored circle with the ranking number inside. The fill comes from the
// backend; the number is always white.
export const RankBadge: React.FC<RankBadgeProps> = React.memo(({ rank, colorHex, size = 24 }) => (
  <Box
    aria-hidden="true"
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorHex,
      color: 'common.white',
      fontWeight: 'bold',
      fontSize: '0.75rem',
      lineHeight: 1,
      fontVariantNumeric: 'tabular-nums',
    }}
  >
    {rank}
  </Box>
))

RankBadge.displayName = 'RankBadge'
